import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const NoResults = styled.div`
  display: flex;
  padding: ${layout.spacing.small} 10px;
`;
